export function replaceObject(objects: any[], object: any): any[] {
  const index = objects.findIndex((({ id }) => id === object.id));
  const objectsList = [...objects];
  objectsList[index] = object;
  return objectsList;
}

export default { replaceObject };
